export default {
    workOrder_createEditCustomer_createTitle: "Create New Customer",
    workOrder_createEditCustomer_editTitle: "Edit Customer",
    workOrder_createEditCustomer_customerSaved: "Customer saved",
    workOrder_createEditCustomer_customerNameIsAlreadyInUse: "The customer name is already in use",
    workOrder_createEditCustomer_customerEinIsAlreadyInUse: "The customer EIN is already in use",
    workOrder_createEditCustomer_contactNameIsAlreadyInUse: "The contact name is already in use",
    workOrder_createEditCustomer_contactPhoneIsAlreadyInUse: "The contact phone is already in use",
    workOrder_createEditCustomer_contactEmailIsAlreadyInUse: "The contact email is already in use",
    workOrder_createEditCustomer_locationNameIsAlreadyInUse: "The location name is already in use",
    workOrder_createEditCustomer_name: "Name",
    workOrder_createEditCustomer_ein: "EIN",
    workOrder_createEditCustomer_mainContact: "Main Contact",
    workOrder_createEditCustomer_phone: "Phone",
    workOrder_createEditCustomer_email: "Email",
    workOrder_createEditCustomer_notifyByPhone: "Notify By Phone",
    workOrder_createEditCustomer_notifyByEmail: "Notify By Email",
    workOrder_createEditCustomer_mainLocation: "Main Location",
    workOrder_createEditCustomer_address: "Address",
    workOrder_createEditCustomer_tags: "Tags",
    workOrder_createEditCustomer_tagsSearch: "Search available tags",
    workOrder_createEditCustomer_contact: "Description",
    workOrder_settingsTagsSearch: "Search available tags",
    workOrder_createEditCustomer_errorPhone: "The phone number must be added",
    workOrder_createEditCustomer_addressFormarError: "The address is not valid",
    workOrder_createEditCustomer_codeCountry: "Code Country"
};